import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import { HOME_FAQS } from '../content/home';

export default function HomeFAQs() {
  const { t, path } = useLocale();
  return (
    <Section aria-labelledby="home-questions-title">
      <div className="container">
        <h2 id="home-questions-title">{t('home.faq.title')}</h2>
        {HOME_FAQS.map(id => (
          <article key={id}>
            <h3>{t(`home.faq.${id}.question`)}</h3>
            <p>{t(`home.faq.${id}.answer`)}</p>
          </article>
        ))}
        <Links>
          <Link to={path('/pricing')}>{t('home.faq.pricing')}</Link>
          <Link to={path('/legal')}>{t('home.faq.privacy')}</Link>
        </Links>
      </div>
    </Section>
  );
}

const Section = styled.section`
  padding: 70px 0;
  background: var(--white);
  .container { max-width: 900px; }
  h2 { color: var(--primary-dark); font-size: clamp(1.75rem, 3vw, 2.5rem); margin-bottom: 36px; }
  article { padding: 24px 0; border-bottom: 1px solid var(--primary-light); }
  h3 { color: var(--primary-dark); margin-bottom: 12px; font-size: 1.2rem; }
  p { line-height: 1.7; }
`;
const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 28px;
  margin-top: 28px;
  a { padding: 8px 0; font-weight: 600; text-decoration: underline; text-underline-offset: 4px; }
`;
